import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import jsonData from "../../data/data.json";
import { auth } from "../../firebaseConfig";
import {
  Row,
  Col,
  Flex,
  Button,
  Card,
  Form,
  Select,
  InputNumber,
  Drawer,
  Space,
  Spin,
  Typography,
} from "antd";
import Profiles from "./Profiles";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import { useAuthState } from "react-firebase-hooks/auth";
import { useUserData } from "../../hooks/useUsers";

const { Title } = Typography;

function Search() {
  let navigate = useNavigate();
  const [user] = useAuthState(auth);
  const { loading, userData } = useUserData(user?.uid);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (userData && !userData.profileCompleted) {
      navigate('/onboarding');
    } else {
      return
    }
  }, [user, userData, loading, navigate]);

  const showDrawer = () => {
    setOpen(true);
  };
  
  const onClose = () => {
    setOpen(false);
  };
  
  const [searchData, setSearchData] = useState({
    maritalStatus: "",
    minAge: "",
    maxAge: "",
    subCaste: "",
    nakshatram: "",
    haveKids: "",
    wantKids: "",
    motherTongue: "",
    education: "",
    employment: "",
    diet: "",
    smoking: "",
    drinking: "",
  });
  
  const [searchForm] = Form.useForm();

  const handleSelect = (name) => (value) => {
    setSearchData({ ...searchData, [name]: value });
  };

  const handleNumberInput = (name) => (value) => {
    setSearchData({ ...searchData, [name]: value });
  };

  const handleReset = () => {
    searchForm.resetFields();
    setSearchData({
      maritalStatus: "",
      minAge: "",
      maxAge: "",
      subCaste: "",
      nakshatram: "",
      haveKids: "",
      wantKids: "",
      motherTongue: "",
      education: "",
      employment: "",
      diet: "",
      smoking: "",
      drinking: "",
    });
  };

  function SearchFilters() {
    return (
      <Card 
        className="shadow-lg border-0"
        style={{ 
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}
      >
        <div style={{ marginBottom: '24px' }}>
          <Title level={3} style={{ color: 'white', marginBottom: 0, textAlign: 'center' }}>
            Search Criteria
          </Title>
        </div>
        
        <Card 
          className="inner-card"
          style={{ 
            borderRadius: '12px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            border: 'none'
          }}
        >
          <Form
            form={searchForm}
            name="search-profiles"
            layout="vertical"
            autoComplete="off"
            size="large"
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item 
                  label={<span style={{ fontWeight: '600' }}>Min Age</span>} 
                  name="minAge"
                >
                  <InputNumber
                    placeholder="18"
                    onChange={handleNumberInput("minAge")}
                    min={18}
                    max={99}
                    style={{ width: '100%', borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item 
                  label={<span style={{ fontWeight: '600' }}>Max Age</span>} 
                  name="maxAge"
                >
                  <InputNumber
                    placeholder="65"
                    onChange={handleNumberInput("maxAge")}
                    min={searchData.minAge || 18}
                    max={99}
                    style={{ width: '100%', borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label={<span style={{ fontWeight: '600' }}>Marital Status</span>}
              name="maritalStatus"
            >
              <Select
                placeholder="Select marital status"
                onChange={handleSelect("maritalStatus")}
                showSearch
                allowClear
                options={jsonData.maritals}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Subcaste</span>} 
              name="subCaste"
            >
              <Select
                placeholder="Select subcaste"
                onChange={handleSelect("subCaste")}
                showSearch
                allowClear
                options={jsonData.subcaste}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Nakshatram</span>} 
              name="nakshatram"
            >
              <Select
                placeholder="Select nakshatram"
                onChange={handleSelect("nakshatram")}
                showSearch
                allowClear
                options={jsonData.nakshatram}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Mother Tongue</span>} 
              name="motherTongue"
            >
              <Select
                placeholder="Select language"
                onChange={handleSelect("motherTongue")}
                showSearch
                allowClear
                options={jsonData.languages}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Have Kids</span>} 
              name="haveKids"
            >
              <Select
                placeholder="Select option"
                onChange={handleSelect("haveKids")}
                showSearch
                allowClear
                options={jsonData.haveKids}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Want Kids</span>} 
              name="wantKids"
            >
              <Select
                placeholder="Select option"
                onChange={handleSelect("wantKids")}
                showSearch
                allowClear
                options={jsonData.wantKids}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Education</span>} 
              name="education"
            >
              <Select
                placeholder="Select education"
                onChange={handleSelect("education")}
                showSearch
                allowClear
                options={jsonData.education}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Employment</span>} 
              name="employment"
            >
              <Select
                placeholder="Select employment"
                onChange={handleSelect("employment")}
                showSearch
                allowClear
                options={jsonData.employment}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Form.Item 
              label={<span style={{ fontWeight: '600' }}>Diet</span>} 
              name="diet"
            >
              <Select
                placeholder="Select diet preference"
                onChange={handleSelect("diet")}
                showSearch
                allowClear
                options={jsonData.diet}
                style={{ borderRadius: '8px' }}
              />
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item 
                  label={<span style={{ fontWeight: '600' }}>Smoking</span>} 
                  name="smoking"
                >
                  <Select
                    placeholder="Select option"
                    onChange={handleSelect("smoking")}
                    showSearch
                    allowClear
                    options={jsonData.smoking}
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item 
                  label={<span style={{ fontWeight: '600' }}>Drinking</span>} 
                  name="drinking"
                >
                  <Select
                    placeholder="Select option"
                    onChange={handleSelect("drinking")}
                    showSearch
                    allowClear
                    options={jsonData.drinking}
                    style={{ borderRadius: '8px' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Flex justify="center" style={{ marginTop: '20px' }}>
              <Button
                type="default"
                onClick={handleReset}
                size="large"
                icon={<ReloadOutlined />}
                style={{ 
                  borderRadius: '8px',
                  height: '45px',
                  minWidth: '140px',
                  fontWeight: '600'
                }}
              >
                Reset Fields
              </Button>
            </Flex>
          </Form>
        </Card>
      </Card>
    );
  }

  return (
    <div style={{ 
      minHeight: '200vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      paddingTop: '150px', // Add padding-top to account for fixed header
      paddingBottom: '20px',
      paddingLeft: '0',
      paddingRight: '0'
    }}>
      <Spin spinning={loading} size="large">
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 20px' }}>
          <Row gutter={[24, 24]}>
            <Col xs={24}>
              <Row gutter={[24, 24]}>
                {/* Mobile Filter Button */}
                <Col xs={24} md={0}>
                  <Space direction="vertical" style={{ width: '100%' }}>
                    <Button 
                      type="primary" 
                      onClick={showDrawer}
                      size="large"
                      icon={<FilterOutlined />}
                      style={{ 
                        borderRadius: '8px',
                        height: '50px',
                        width: '100%',
                        fontWeight: '600',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderColor: 'rgba(255, 255, 255, 0.3)',
                        backdropFilter: 'blur(10px)'
                      }}
                    >
                      Search Filters
                    </Button>
                  </Space>
                  <Drawer
                    title={
                      <span style={{ 
                        fontSize: '18px', 
                        fontWeight: '600',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}>
                        Search Filters
                      </span>
                    }
                    placement="left"
                    onClose={onClose}
                    open={open}
                    width={350}
                    styles={{
                      body: { padding: '20px' }
                    }}
                  >
                    <SearchFilters />
                  </Drawer>
                </Col>

                {/* Desktop Sidebar */}
                <Col xs={0} md={8} xl={6}>
                  <SearchFilters />
                </Col>

                {/* Profiles Section */}
                <Col xs={24} md={16} xl={18}>
                  <Card 
                    className="shadow-lg border-0"
                    style={{ 
                      borderRadius: '16px',
                      minHeight: '600px',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      backdropFilter: 'blur(10px)'
                    }}
                  >
                    <Profiles searchCriteria={searchData} />
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Spin>
    </div>
  );
}

export default Search;